import React from 'react'
import { Link } from 'react-router-dom'
import {
    Button,
    Drawer,
    Grid,
    Icon,
    Pagination,
} from '@softwaredev_cegeka/stix-core'

import { AuthApi } from 'src/api/authApi'
import { authenticatedUserStore, notifierStore } from 'src/stores'
import { ApplicationTable } from 'src/components/EntityTable'
import ApplicationDrawerContent from 'src/components/Drawer/ApplicationDrawerContent'

import './contentRoute.scss'

class ApplicationRoute extends React.Component {
    state = {
        applications: [],
        selectedApplication: null,
        page: 1,
        totalPages: 1,
        totalElements: 1,
        loading: false,
        params: {},
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidMount() {
        this.fetchAndStoreApplications()
    }

    // Cancel still ongoing get requests, to prevent updating state and changing the page to the previous clicked link
    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    rowSelectHandler = async (selectObj, setDrawerState) => {
        const { selectedRow } = selectObj

        this.setState(
            {
                selectedApplication: selectedRow.original.id,
            },
            () => setDrawerState(true)
        )
    }

    fetchAndStoreApplications = (page = this.state.page) => {
        this.setState({ loading: true })
        this.authClient
            .fetchApplications(page, this.props.history, this.state.params)
            .then(response => {
                this.setState({
                    applications: response?.data?.results,
                    totalPages: response?.data?._page.total_pages,
                    totalElements: response?.data?._page.total_elements,
                    loading: false,
                    page: page,
                })
            })
            .catch(err => console.error(err))
    }

    removeApplication = (id, name) => {
        this.authClient
            .deleteApplication(id)
            .then(response => {
                if (response.status === 200 || response.status === 204) {
                    this.fetchAndStoreApplications(this.state.page)
                    notifierStore.setToastInfo(
                        'Application ' + name + ' successfully deleted',
                        true
                    )
                } else {
                    notifierStore.setToastInfo(
                        'Failed to remove application ' + name,
                        false
                    )
                }
            })
            .catch(err => {
                notifierStore.setToastInfo(err.response?.data?.error, false)
            })
        notifierStore.setShowMessage(true)
    }

    setParams = params => {
        this.setState(
            {
                params: params,
            },
            () => this.fetchAndStoreApplications(1)
        )
    }

    handlePageChange = page => {
        this.setState({ page: page }, () => this.fetchAndStoreApplications())
    }

    getSelectedApplication() {
        return this.state.applications.find(application => {
            return application.id === this.state.selectedApplication
        })
    }

    render() {
        const selectedApplication = this.getSelectedApplication() || {}
        return (
            <div className="entity-drawer">
                <Drawer
                    type="fixed"
                    panelTitle={selectedApplication.name}
                    panelContent={
                        <ApplicationDrawerContent
                            application={selectedApplication}
                        />
                    }
                >
                    <Grid.Container>
                        <div className={'page-header'}>
                            <h1 className="content-title">
                                Applications overview
                            </h1>
                            <Link
                                to={{
                                    pathname:
                                        authenticatedUserStore.isGlobalAdmin
                                            ? '/application-form'
                                            : '/unauthorized',
                                }}
                            >
                                <Button variant="secondary">
                                    <Icon icon="add" />
                                    <span>Create application</span>
                                </Button>
                            </Link>
                        </div>

                        <Drawer.Context.Consumer>
                            {({ setDrawerState }) => (
                                <ApplicationTable
                                    {...this.props}
                                    data={this.state.applications}
                                    loading={this.state.loading}
                                    params={this.state.params}
                                    setParams={this.setParams}
                                    deleteAction={(id, name) =>
                                        this.removeApplication(id, name)
                                    }
                                    rowSelectHandler={selectObj =>
                                        this.rowSelectHandler(
                                            selectObj,
                                            setDrawerState
                                        )
                                    }
                                />
                            )}
                        </Drawer.Context.Consumer>

                        {this.state.totalPages >= 2 && (
                            <div className="pagination-wrapper">
                                <Pagination
                                    lastPage={this.state.totalPages}
                                    currentPage={this.state.page}
                                    onClick={
                                        this.state.loading
                                            ? () => {}
                                            : this.handlePageChange
                                    }
                                />
                            </div>
                        )}
                    </Grid.Container>
                </Drawer>
            </div>
        )
    }
}

export default ApplicationRoute
